<template>
    <div class="md-layout text-center login-fix-page">
        <div class="md-layout-item md-size-50 md-medium-size-50 md-small-size-70 md-xsmall-size-100 login-page-fix">
            <form @submit.prevent="reset">
                <login-card class="md-card-reset" header-color="green">
                    <h4 slot="title" class="title">Réinitialiser son mot de passe</h4>
                    <md-field class="form-group md-invalid"
                        slot="inputs"
                        style="margin-bottom: 28px">
						<i class="md-icon far fa-envelope"></i>
                        <label>Email</label>
                        <md-input v-model="email" type="email"/>
                        <validation-error :errors="apiValidationErrors.email"/>
                    </md-field>
                    <md-field class="form-group md-invalid"
                        slot="inputs"
                        style="margin-bottom: 28px">
						<i class="md-icon fas fa-key"></i>
                        <label>Mot de passe</label>
                        <md-input v-model="password" type="password"/>
                        <validation-error :errors="apiValidationErrors.password"/>
                    </md-field>
                    <md-field class="form-group md-invalid"
                        slot="inputs"
                        style="margin-bottom: 28px">
						<i class="md-icon fas fa-key"></i>
                        <label>Comfirmer le mot de passe</label>
                        <md-input v-model="passwordConfirmation" type="password"/>
                        <validation-error :errors="apiValidationErrors.password_confirmation"/>
                    </md-field>
                    <md-button slot="footer"
                        class="md-simple md-success md-lg"
                        type="submit">
                        Enregistrer
                    </md-button>
                </login-card>
            </form>
        </div>
    </div>
</template>

<script>
import {LoginCard, ValidationError} from "@/components";
import formMixin from "@/mixins/form-mixin";

export default {
    name: 'PasswordForgottenComponent',
    components: {
        LoginCard,
        ValidationError,
    },
    mixins: [formMixin],
    computed: {
        isAuthenticated: function () {
            return this.$store.getters.isAuthenticated();
        },
    },
    data: () => ({
        email: '',
        password: '',
        passwordConfirmation: '',
    }),
    methods: {
        async reset() {
            const data = {
                attributes: {
                    email: this.email,
                    password: this.password,
                    password_confirmation: this.passwordConfirmation,
                    token: this.$route.params.token,
                },
            };

            const requestOptions = {
                headers: {
                    Accept: "application/vnd.api+json",
                    "Content-Type": "application/vnd.api+json",
                },
            };

            try {
				this.resetApiValidation();
                await this.$store.dispatch("reset", {data, requestOptions});
				await this.$store.dispatch("alerts/success","Mot de passe modifié");
                await this.$router.push({name: 'Login'})
            } catch (e) {
				if(e.response.data.errors) {
					if(e.response.data.errors['token']) {
						// token invalid
						await this.$store.dispatch("alerts/error","Le lien de réinitialisation a expiré");
					} else {
						let apiError = []
						let emailErrors = this.checkArrayLength(e.response.data.errors['email'])
						let passwordErrors = this.checkArrayLength(e.response.data.errors['password'])
						apiError = [
							...emailErrors.map(error => this.checkMessageError('email', error)),
							...passwordErrors.map(error => this.checkMessageError('password', error))
						]
						this.setApiValidation(apiError);
					}
				} else {
					if(e.response.data.message === 'This email is invalid.') {
						// email invalid with this token
						this.setApiValidation([{
							source: { pointer: '/reset/password/email' },
							detail: 'L\'adresse email est invalide'
						}]);
					} else {
						await this.$store.dispatch("alerts/error","Une erreur est survenue");
					}
				}
            }
        },
		checkMessageError(field, error) {
			let errorMessage = ''
			switch(field) {
				case 'email':
					errorMessage = {
						source: { pointer: '/reset/password/email' },
						detail: error
					}
					break
				case 'password':
					errorMessage = {
						source: { pointer: '/reset/password/password' },
						detail: error
					}
					break
				default:
					errorMessage = {
						source: { pointer: '/reset/password/email' },
						detail: 'Une erreur est survenue'
					}
					break
			}
			return errorMessage
		},
		checkArrayLength(array) {
			if(array) {
				return array
			} else {
				return []
			}
		}
    }
};
</script>
<style lang="scss" scoped>
.login-fix-page {
    padding-bottom: 7em;
    padding-top: 4em;
}
.md-card-reset::v-deep {
	max-width: 100%;
	margin: 0;
	text-align: left;
	.md-error {
		line-height: 1.25em !important;
		bottom: -12px !important;
	}
}
</style>
